// client/src/neetjee_guru/components/libraryManagement/queries.js
import gql from "graphql-tag";

export const GET_LIBRARY_DASHBOARD = gql`
  query getLibraryDashboard($institute_id: Int!, $branch_id: Int!) {
    getLibraryDashboard(institute_id: $institute_id, branch_id: $branch_id) {
      total_books
      total_copies
      active_loans
      overdue_loans
      fine_collected_today
      pending_fines
    }
  }
`;

export const GET_BOOKS = gql`
  query getBooks($institute_id: Int!, $branch_id: Int!) {
    getBooks(institute_id: $institute_id, branch_id: $branch_id) {
      id
      title
      author
      isbn
      category
      language
      price
      subject
      total_copies
      available_copies
      copies {
        id
        book_id
        accession_no
        rack_location
        status
        institute_id
        branch_id
      }
      institute_id
      branch_id
    }
  }
`;

export const SEARCH_LIBRARY_STUDENT = gql`
  query searchLibraryStudent($q: String!, $institute_id: Int!, $branch_id: Int!) {
    searchLibraryStudent(q: $q, institute_id: $institute_id, branch_id: $branch_id) {
      id
      student_name
      admission_no
      roll_no
      class_name
      section_name
    }
  }
`;

export const SEARCH_AVAILABLE_BOOKS = gql`
  query searchAvailableBooks($q: String!, $institute_id: Int!, $branch_id: Int!) {
    searchAvailableBooks(q: $q, institute_id: $institute_id, branch_id: $branch_id) {
      id
      title
      author
      isbn
      category
      language
      price
      subject
      total_copies
      available_copies
      copies {
        id
        book_id
        accession_no
        rack_location
        status
        institute_id
        branch_id
      }
      institute_id
      branch_id
    }
  }
`;

export const GET_STUDENT_ACTIVE_LOANS = gql`
  query getStudentActiveLoans($borrower_id: Int!, $borrower_type: String!, $institute_id: Int!, $branch_id: Int!) {
    getStudentActiveLoans(borrower_id: $borrower_id, borrower_type: $borrower_type, institute_id: $institute_id, branch_id: $branch_id) {
      id
      borrower_type
      borrower_id
      borrower_name
      borrower_code
      copy_id
      accession_no
      book_id
      book_title
      issue_date
      due_date
      return_date
      renew_count
      status
      loan_type
      institute_id
      branch_id
      overdue_days
      fine_amount
      rack_location
    }
  }
`;

export const GET_LIBRARY_FINES = gql`
  query getLibraryFines($status: String, $institute_id: Int!, $branch_id: Int!) {
    getLibraryFines(status: $status, institute_id: $institute_id, branch_id: $branch_id) {
      id
      issue_id
      borrower_name
      borrower_code
      book_title
      accession_no
      fine_type
      fine_amount
      paid_amount
      balance_amount
      status
      waive_reason
      created_at
    }
  }
`;

export const GET_LIBRARY_REPORT = gql`
  query getLibraryReport($type: String!, $from: String, $to: String, $institute_id: Int!, $branch_id: Int!) {
    getLibraryReport(type: $type, from: $from, to: $to, institute_id: $institute_id, branch_id: $branch_id) {
      id
      date
      type
      description
      student_name
      class_name
      section_name
      amount
    }
  }
`;

export const GET_LIBRARY_SETTINGS = gql`
  query getLibrarySettings($institute_id: Int!, $branch_id: Int!) {
    getLibrarySettings(institute_id: $institute_id, branch_id: $branch_id) {
      library_name
      timings
      fine_per_day
      max_borrow_days
      max_books
      max_renewals
      semester_borrow_days
      max_semester_books
      institute_id
      branch_id
    }
  }
`;

export const GET_BOOKS_PAGINATED = gql`
  query getBooksPaginated($institute_id: Int!, $branch_id: Int!, $limit: Int!, $offset: Int!, $search: String) {
    getBooksPaginated(institute_id: $institute_id, branch_id: $branch_id, limit: $limit, offset: $offset, search: $search) {
      books {
        id
        title
        author
        isbn
        category
        language
        price
        subject
        total_copies
        available_copies
        copies {
          id
          book_id
          accession_no
          rack_location
          status
          institute_id
          branch_id
        }
        institute_id
        branch_id
      }
      totalCount
    }
  }
`;

export const GET_LIBRARY_REPORT_PAGINATED = gql`
  query getLibraryReportPaginated($type: String!, $from: String, $to: String, $limit: Int!, $offset: Int!, $institute_id: Int!, $branch_id: Int!) {
    getLibraryReportPaginated(type: $type, from: $from, to: $to, limit: $limit, offset: $offset, institute_id: $institute_id, branch_id: $branch_id) {
      rows {
        id
        date
        type
        description
        student_name
        class_name
        section_name
        amount
      }
      totalCount
    }
  }
`;

export const GET_STUDENTS = gql`
  query getStudents($institution_id: Int!) {
    getStudents(institution_id: $institution_id) {
      id
      student_name
      contact_no
      branch_id
      class_id
      section_id
      package_id
      category_id
      exam_id
    }
  }
`;

export const GET_EMPLOYEES = gql`
  query getEmployees($institute_id: Int, $branch_id: Int) {
    getEmployees(institute_id: $institute_id, branch_id: $branch_id) {
      employee_id
      employee_name
      subject_ids
      employee_type_id
    }
  }
`;

export const GET_NEW_EDUCATIONAL_STUDENTS = gql`
  query getCombinedAcademicAndNonAcademicStudents($institution_id: Int!, $branch_id: String) {
    getNewEducationalStudents: getCombinedAcademicAndNonAcademicStudents(institution_id: $institution_id, branch_id: $branch_id) {
      student_id: edu_student_id
      student_name
      roll_no
      admission_no
      class_name
      section_name
      branch_name
      branch_id
      class_id
      section_id
    }
  }
`;

export const GET_LOAN_BY_ACCESSION_NO = gql`
  query getLoanByAccessionNo($accession_no: String!, $institute_id: Int!, $branch_id: Int!) {
    getLoanByAccessionNo(accession_no: $accession_no, institute_id: $institute_id, branch_id: $branch_id) {
      id
      borrower_type
      borrower_id
      borrower_name
      borrower_code
      copy_id
      accession_no
      book_id
      book_title
      issue_date
      due_date
      return_date
      renew_count
      status
      loan_type
      institute_id
      branch_id
      overdue_days
      fine_amount
      rack_location
    }
  }
`;
